import { z } from "zod"
import { SalesAddressModelSchema } from "./SalesAddressModel"
import { SalesEmailSchema, SalesFirstNameSchema, SalesLastNameSchema, SalesPhoneNumberSchema } from "./SalesCommons"

/**
 * S&O sales contact entity schema
 */
export const SalesContactModelSchema = z.object({
	id: z.string().min(1),

	email: SalesEmailSchema,

	first_name: SalesFirstNameSchema,

	last_name: SalesLastNameSchema,

	phone: SalesPhoneNumberSchema,

	addresses: z.array(SalesAddressModelSchema),
})

export type SalesContactModel = z.infer<typeof SalesContactModelSchema>
